<tmo-dynamic-modal [displayModal]="displayModal" [modal]="modal" (onHide)="closeModal()">
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        href="javascript:void(0)"
        aria-label="staticContent?.closeModal"
        class="close-x"
        (click)="closeModal()"
        id="cta-default-217"
      >
        <i class="fa fa-times"></i>
      </a>
    </div>
    <h3>{{ staticContent?.touristPlanConflictAlert }}</h3>
  </ng-container>

  <p>{{ staticContent?.touristPlanConflictMessage }}</p>

  <ng-container footer>
    <div class="row">
      <div class="col-12 buttons-container button-spacing">
        <div class="button-box" *ngIf="!isTestDrivePlan">
          <button
            class="btn btn-secondary"
            id="select-stand-alone"
            *ngIf="!isByos || isPlan"
            aria-label="staticContent?.standAloneDevice"
            (click)="selectStandaloneDevice()"
          >
            {{ staticContent?.standAloneDevice }}
          </button>
        </div>
        <div class="button-box">
          <button
            class="btn btn-primary"
            id="go-to-current-cart"
            aria-label="staticContent?.deviceErrorModalPrimaryCTA"
            (click)="goToCurrentCartSelection()"
          >
            {{ staticContent?.deviceErrorModalPrimaryCTA }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</tmo-dynamic-modal>
